var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('canvas',{attrs:{"id":_vm.index,"height":"50","width":"50"}})])}
var staticRenderFns = []

export { render, staticRenderFns }